import { applicationTypeGeneratePrompt } from './applicationType/applicationTypeGeneratePrompt';
import { applicationTypeRegeneratePrompt } from './applicationType/applicationTypeRegeneratePrompt';
import { applicationTypeVerifyPrompt } from './applicationType/applicationTypeVerifyPrompt';
import { fileRewritePrompt } from './edits/fileRewritePrompt';
import { namePrompt } from './namePrompt';
import { aclGeneratePrompt } from './schema/aclGeneratePrompt';
import { schemaFixPrompt } from './schema/schemaFixPrompt';
import { schemaModelGeneratePrompt } from './schema/schemaModelGeneratePrompt';
import { schemaTempModelGeneratePrompt } from './schema/schemaTempModelGeneratePrompt';
import { schemaUpdatePrompt } from './schema/schemaUpdatePrompt';
import { generateSpecificationPrompt } from './specification/generateSpecificationPrompt';
import { checkStructurePrompt, cleanUpStructurePrompt, generateLinksStructurePrompt, generateSpecialViewsStructurePrompt, generateStructureDetailsPrompt, generateStructureFormsPrompt, generateStructurePrompt, navigationPrompt, planStructurePrompt, structureFixPrompt, updateStructurePrompt, } from './structure';
import { generateStructurePersistEventsPrompt } from './structure/generateStructurePersistEventsPrompt';
import { generateStructurePreviewsPrompt } from './structure/generateStructurePreviewsPrompt';
import { generateStructureScopesPrompt } from './structure/generateStructureScopesPrompt';
import { generateStructureViewsPrompt } from './structure/generateStructureViewsPrompt';
export var promptKeys;
(function (promptKeys) {
    promptKeys["NAME_PROMPT"] = "contember_name_prompt";
    promptKeys["APPLICATION_TYPE"] = "contember_application_type";
    promptKeys["VERIFY_APPLICATION_TYPE"] = "contember_verify_application_type";
    promptKeys["REGENERATE_APPLICATION_TYPE"] = "contember_regenerate_application_type";
    promptKeys["GENERATE_ENTITIES_DSL"] = "contember_generate_entities_dsl";
    promptKeys["GENERATE_TEMP_ENTITIES_DSL"] = "contember_generate_temp_entities_dsl";
    promptKeys["UPDATE_SCHEMA_DSL"] = "contember_update_schema_dsl";
    promptKeys["FIX_SCHEMA_DSL"] = "contember_fix_schema_dsl";
    promptKeys["GENERATE_ACL_DSL"] = "contember_generate_acl_dsl";
    promptKeys["GENERATE_NAVIGATION_DSL"] = "contember_generate_navigation_dsl";
    promptKeys["GENERATE_SPECIFICATION"] = "contember_generate_specification";
    promptKeys["PLAN_APP_STRUCTURE_DSL"] = "contember_plan_app_structure_dsl";
    promptKeys["GENERATE_APP_STRUCTURE_DSL"] = "contember_generate_app_structure_dsl";
    promptKeys["GENERATE_STRUCTURE_VIEWS"] = "contember_generate_structure_views";
    promptKeys["GENERATE_STRUCTURE_SCOPES"] = "contember_generate_structure_scopes";
    promptKeys["GENERATE_STRUCTURE_FORMS"] = "contember_generate_structure_forms";
    promptKeys["GENERATE_PERSIST_EVENTS"] = "contember_generate_persist_events";
    promptKeys["GENERATE_STRUCTURE_DETAILS"] = "contember_generate_structure_details";
    promptKeys["GENERATE_STRUCTURE_PREVIEWS"] = "contember_generate_structure_previews";
    promptKeys["CHECK_APP_STRUCTURE_DSL"] = "contember_check_app_structure_dsl";
    promptKeys["UPDATE_APP_STRUCTURE_DSL"] = "contember_update_app_structure_dsl";
    promptKeys["GENERATE_SPECIAL_VIEWS_APP_STRUCTURE_DSL"] = "contember_generate_special_views_app_structure_dsl";
    promptKeys["GENERATE_LINKS_APP_STRUCTURE_DSL"] = "contember_generate_links_app_structure_dsl";
    promptKeys["CLEAN_UP_APP_STRUCTURE_DSL"] = "contember_clean_up_app_structure_dsl";
    promptKeys["FIX_STRUCTURE_DSL"] = "contember_fix_structure_dsl";
    promptKeys["EDITS_FILE_CHANGE"] = "contember_edits_file_change";
})(promptKeys || (promptKeys = {}));
export const prompts = {
    [promptKeys.NAME_PROMPT]: namePrompt,
    [promptKeys.APPLICATION_TYPE]: applicationTypeGeneratePrompt,
    [promptKeys.VERIFY_APPLICATION_TYPE]: applicationTypeVerifyPrompt,
    [promptKeys.REGENERATE_APPLICATION_TYPE]: applicationTypeRegeneratePrompt,
    [promptKeys.GENERATE_ENTITIES_DSL]: schemaModelGeneratePrompt,
    [promptKeys.GENERATE_TEMP_ENTITIES_DSL]: schemaTempModelGeneratePrompt,
    [promptKeys.UPDATE_SCHEMA_DSL]: schemaUpdatePrompt,
    [promptKeys.FIX_SCHEMA_DSL]: schemaFixPrompt,
    [promptKeys.GENERATE_ACL_DSL]: aclGeneratePrompt,
    [promptKeys.GENERATE_SPECIFICATION]: generateSpecificationPrompt,
    [promptKeys.PLAN_APP_STRUCTURE_DSL]: planStructurePrompt,
    [promptKeys.GENERATE_APP_STRUCTURE_DSL]: generateStructurePrompt,
    [promptKeys.GENERATE_STRUCTURE_VIEWS]: generateStructureViewsPrompt,
    [promptKeys.GENERATE_STRUCTURE_SCOPES]: generateStructureScopesPrompt,
    [promptKeys.GENERATE_STRUCTURE_FORMS]: generateStructureFormsPrompt,
    [promptKeys.GENERATE_STRUCTURE_DETAILS]: generateStructureDetailsPrompt,
    [promptKeys.GENERATE_PERSIST_EVENTS]: generateStructurePersistEventsPrompt,
    [promptKeys.GENERATE_STRUCTURE_PREVIEWS]: generateStructurePreviewsPrompt,
    [promptKeys.CHECK_APP_STRUCTURE_DSL]: checkStructurePrompt,
    [promptKeys.UPDATE_APP_STRUCTURE_DSL]: updateStructurePrompt,
    [promptKeys.GENERATE_SPECIAL_VIEWS_APP_STRUCTURE_DSL]: generateSpecialViewsStructurePrompt,
    [promptKeys.CLEAN_UP_APP_STRUCTURE_DSL]: cleanUpStructurePrompt,
    [promptKeys.GENERATE_LINKS_APP_STRUCTURE_DSL]: generateLinksStructurePrompt,
    [promptKeys.GENERATE_NAVIGATION_DSL]: navigationPrompt,
    [promptKeys.FIX_STRUCTURE_DSL]: structureFixPrompt,
    [promptKeys.EDITS_FILE_CHANGE]: fileRewritePrompt,
};
//# sourceMappingURL=prompts.js.map